var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('obk-description-partner-note-step',{attrs:{"step-number":"1"}}),_vm._v(" "),_c('obk-description-no-incognito-step',{attrs:{"step-number":"2"}}),_vm._v(" "),_c('obk-description-no-ad-blocker-step',{attrs:{"step-number":"3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }